import { render, staticRenderFns } from "./CharacterVideo.vue?vue&type=template&id=0d1bdbf3&scoped=true&"
import script from "./CharacterVideo.vue?vue&type=script&lang=js&"
export * from "./CharacterVideo.vue?vue&type=script&lang=js&"
import style0 from "./CharacterVideo.vue?vue&type=style&index=0&id=0d1bdbf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1bdbf3",
  null
  
)

export default component.exports